import React, { Component } from 'react'
import { connect } from 'react-redux'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'

import {
    updateInputs,
    buscarDocumento,
    reiniciarEstado,
} from '../actions/busquedadocumento'

import history from '../utils/history'
import store from '../utils/store'


const ENTER_KEY = 13

class BusquedaDocumentos extends Component {



    componentWillUnmount() {
        this.props.reiniciarEstado()
    }

    handleOnKeyDown = (key) => {
        if (key === ENTER_KEY) {
            this.props.buscarDocumento()
        }
    }
	render() {

        const { tipo, busqueda, documentos, enums } = this.props
        
        const boxActions = [
            <BoxButton key="ba[11][0]" name="search" onClick={ e => this.props.buscarDocumento() } title="Buscar documento"/>,
        ]

		return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Búsqueda de documentos" stretch>
                        <ButtonStrip 
                            actions={ boxActions }
                        />
                        <div className="box-content" style={{ flex: 1, height: 0 }}>
                            <div style={{ display: 'flex', height: '100%', justifyContent: 'space-between', flexDirection: 'column' }}>
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Tipo</label>
                                            <select className="form-control input-sm" value={ tipo || '' } onChange={ (e) => this.props.updateInputs('tipo', e.target.value) }>
                                                <option value={0}>Todos</option>
                                                {
                                                    enums.getIn(['documentos', 'tipos']).valueSeq().map(x => {
                                                        if (x.get('CODIGO') == 4) return null;
                                                        if (x.get('CODIGO') == 6) return null;
                                                        return (
                                                            <option key={`opt[3][${x.get('CODIGO')}]`} value={x.get('CODIGO')}>{ x.get('NOMBRE') }</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="form-group">
                                            <label className="control-label">Consecutivo</label>
                                            <input type="text" className="form-control input-sm" value={ busqueda || '' } onChange={ (e) => this.props.updateInputs('busqueda', e.target.value) } onKeyDown={ (e) => this.handleOnKeyDown(e.keyCode) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                                    <div className="col-md-12">
                                        <div style={{ borderTop: '1px solid #ddd' }}>
                                        {
                                                documentos.map((x, n) => {

                                                    if (x.get('tipo') == 4) return null

                                                    const docName = enums.getIn(['documentos','tipos',String(x.get('tipo')),'NOMBRE'])
                                                    const prefix = enums.getIn(['documentos','tipos',String(x.get('tipo')),'PREFIJO'])
                                                    const estado = enums.getIn(['documentos','estados',String(x.get('estado'))])                                                
                                                    
                                                    return (
                                                        <div key={ x.get('id') } className="documento-search-result" onClick={ () => history.push(window.FOLDER + `/documentos/${x.get('id')}`) }>
                                                            <div><strong style={{ fontSize: '1.2em' }}>{ docName }</strong></div>
                                                            <div><span className="label label-primary">{ prefix }{ x.get('consecutivo') }</span></div>
                                                            <div><strong>No. Solicitud:</strong> <span style={{ fontWeight: '100' }}>{ x.getIn(['solicitude','id']) }</span></div>
                                                            <div><strong>Estado:</strong> <span style={{ fontWeight: '100' }}> { estado } </span></div>
                                                            <div><strong>Actividad/Evento:</strong> <span style={{ fontWeight: '100' }}>{ x.getIn(['solicitude','proyecto_evento']) }</span></div>
                                                        </div>
                                                    )
                                                })

                                        }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        documentos: state.busquedadocumento.get('documentos'),
        tipo: state.busquedadocumento.get('tipo'),
        busqueda: state.busquedadocumento.get('busqueda'),
        enums: state.common.get('enums')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        buscarDocumento: () => dispatch(buscarDocumento()),
        reiniciarEstado: () => dispatch(reiniciarEstado()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BusquedaDocumentos)


// WEBPACK FOOTER //
// ./src/containers/BusquedaDocumentos.jsx